module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_rycmmi@2x.5e9da868.png";